import { CoverImage } from '@wix/pricing-plans-utils/client-data';
import { demoImages, demoImagesEditor3, demoImagesStudio, EditorType } from '../fixtures/plans';

export function getDefaultPlanImage(editor?: EditorType): CoverImage {
  const editorType = editor ?? 'classic';
  if (editorType === 'editor3') {
    return demoImagesEditor3.default;
  }

  if (editorType === 'studio') {
    return demoImagesStudio.image3;
  }

  return demoImages.image3;
}

export function getDefaultPlanImageUri(editor?: EditorType): string {
  return getDefaultPlanImage(editor).uri;
}
